module.exports = __webpack_public_path__ + "static/media/lineChart.236ec18f.svg";